import Header from "../common/Header";
import React, { useEffect, useMemo, useRef, useState } from "react";
import InputSection from "../input-section";
import { useNavigate, useParams } from "react-router-dom";
import CalculationSection from "../calculation-section";
import useProjectFacade from "../../facade/project.Facade";
import ProjectHeader from "../projectheader";
import ProjectSummary from "../common/projectsummary";
import { Splitter, SplitterOnChangeEvent } from "@progress/kendo-react-layout";
import Notification from "../common/notification";
import useCalculationFacade from "../../facade/calculation/calculation.facade";
import useProjectTabFacade from "../../facade/calculation/calculation-input/projectTab.Facade";
import ButtonGroup from "../common/button-group";
import { useAppSelector, useAppDispatch } from "../../store/hooks/StoreHooks";
import { setNavigationLoading } from "../../store/calculation/calculation-input/ProjectHeaderSlice";
import Comparison from "../comparison";
import Drawer from "../common/Drawer";
import CreateProject from "../common/project-create";
import useTubingFacade from "../../facade/calculation/calculation-input/tubing.facade";
import Reports from "../Reports";
import useReportFacade from "../../facade/report/report.facade";
import useComparisonFacade from "../../facade/comparison/comparison.facade";
import Loader from "../common/loader";
import Dropdown2 from "../common/dropdown/dropdown2";
import ShareWithCustomer from "./ShareWithCustomer";
import { showToast } from "../../utilities/commonUtilities";
import { ProjectStatus, RoleConstants } from "../../utilities/AppConstants";
import AcknowledgeDropdown from "./acknowledge-dropdown";
import useCreateProjectFacade from "../../facade/createProject.Facade";
import useProjectHeaderFacade from "../../facade/calculation/calculation-input/projectHeader.facade";
import { ToastContainer } from "react-toastify";
import Jetlift from "../jetlift";
import useJetliftCalculationFacade from "../../facade/jetlift/jetliftCalculations.facade";
import { designType } from "../../utilities/CasingConstant";

interface Project {
  id: string;
  name: string;
}

const ProjectDetails: React.FC = () => {
  const dispatch = useAppDispatch();
  const { ID, caseID } = useParams();
  const projectID = ID?.split("projectID=")?.[1] || "";
  const caseId = caseID?.split("caseID=")?.[1] || "";
  const templateId = ID?.split("templateID=")?.[1] || "";
  const { loadCasingOD } = useTubingFacade();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const drawerOpenFormSnapshotRef = useRef<Record<string, any> | null>(null);
  const prevProjectIdRef = useRef<string | undefined>(undefined);
  const prevCaseIdRef = useRef<string | undefined>(undefined);
  const lastLoadedJetliftRef = useRef<{ projectID: string; caseId: string } | null>(null);
  const [projectActionsLoading, setProjectActionsLoading] =
    useState<boolean>(false);
  const [showShareDialog, setShowShareDialog] = useState<boolean>(false);
  const { loadProjectDetails, loadTemplateCalculations, SaveProject } =
    useCalculationFacade();
  const { isComparison } = useAppSelector((state) => state?.comparison);
  const { isReports, isProjectDetails } = useAppSelector(
    (state) => state?.reports
  );
  const { loading } = useAppSelector((state) => state?.calculations);
  const jetLiftLoading = useAppSelector((state) => state?.jetlift?.calculations?.loading);
  const { selectedProject, sharedCases }: any = useAppSelector(
    (state) => state?.myProjects
  );
  const [horizontalPanes, setHorizontalPanes] = useState<Array<any>>([
    { size: "30%", collapsible: true },
    {},
    { size: "70%", collapsible: true },
  ]);
  const {
    getUpdatedSelectedProject,
    triggerUpdateProjectStatus,
    triggerGetSharedCases,
    updateCaseDetails,
  } = useProjectFacade();
  const { updateProjectStatus } = useCalculationFacade();
  const { updateIsReport, updateIsProjectDetails } = useReportFacade();
  const { updateIsComparison } = useComparisonFacade();
  const { updatProjectTabDetails } = useProjectTabFacade();
  const {
    updateProjectName,
    updateCustomer,
    updateWell,
    updateCustomerSearch,
    updateWellSearch,
    updateCountry,
    updateCounty,
    updateState,
    updateOtherCounty,
    updateStateList,
    updateCountryList,
    updateCountyList,
    updateWellApiNo,
    updateCaseName,
    UpdateCaseDescription,
    updateFormation,
    updateAccountManager,
    updateContact,
    updateLiftOption,
  } = useCreateProjectFacade();
  const { getProjectAndAffiliationsDetails, updateProjectAffiliations } =
    useProjectHeaderFacade();
  const { loadJetliftProjectDetails, loadJetlifttemplateCalculations, SaveJetliftProject } = useJetliftCalculationFacade();
  const { projectDetails, error } = useAppSelector(
    (state) => state?.calculations
  );
  const { user } = useAppSelector((state) => state.auth);
  const { tab4Input } = useAppSelector((state) => state?.projectTab);
  const navigate = useNavigate();
  const [projectStates, setProjectStates] = useState<any[]>([]);

  const [notification, setNotification] = useState({
    type: "",
    message: "",
    show: false,
  });
  const [dropdownActive, setDropdownActive] = useState(false);

  const projectObject: any = {
    projectID: selectedProject?.projectID ?? projectID,
    projectName: selectedProject?.projectName || "",
    caseID: caseId,
  };

  const {
    projectName,
    caseName,
    contact,
    country,
    wellApiNo,
    represtative,
    equiment,
    formation,
    county,
    countyOther,
    customer,
    state,
    well,
    caseDescription,
    customerSearchKey,
    wellSearchKey,
    accountManager,
    stateList,
    countyList,
    liftOption,
  } = useAppSelector((state) => state?.createProject);
  const { customerEnabled, customerCreated } = useAppSelector((state) => state?.auth);
  const { projectReadOnly, projectAndAffiliations } = useAppSelector((state) => state?.projectHeader);
  const projectAffiliationLoading = useAppSelector((state) => state?.projectHeader?.loading);

  const [projectData, setProjectData] = useState({
    projectName,
    caseName,
    contact,
    country,
    wellApiNo,
    represtative,
    equiment,
    formation,
    county,
    countyOther,
    customer,
    state,
    well,
  });

  useEffect(() => {
    if (error?.includes("403")) {
      navigate("/no-project-access");
    }
  }, [error]);

  useEffect(() => {
    setProjectData({
      projectName,
      caseName,
      contact,
      country,
      wellApiNo,
      represtative,
      equiment,
      formation,
      county,
      countyOther,
      customer,
      state,
      well,
    });
  }, [
    projectName,
    caseName,
    contact,
    country,
    wellApiNo,
    represtative,
    equiment,
    formation,
    county,
    countyOther,
    customer,
    state,
    well,
  ]);

  const onHorizontalChange = (event: SplitterOnChangeEvent) => {
    setHorizontalPanes(event.newState);
  };

  useEffect(() => {
    const hasAffiliations = projectAndAffiliations?.length > 0;
    const projectOrCaseChanged =
      !hasAffiliations ||
      prevProjectIdRef.current !== projectID ||
      prevCaseIdRef.current !== caseId;
    getUpdatedSelectedProject(projectObject);

    if (projectOrCaseChanged && (projectID !== "" || caseId) && hasAffiliations && projectAndAffiliations?.find((x: any) => x.projectID === (caseId ? caseId : projectID))?.liftType === 1) {
      (async () => {
        dispatch(setNavigationLoading(true));

        await getUpdatedSelectedProject(projectObject);
        loadProjectDetails({
          SortDto: { Field: "UpdatedOn", Order: "DESC" },
          Filters: [],
          GlobalFilter: "",
          PageNumber: 1,
          PageSize: 10,
        }
        );
        updateIsProjectDetails(true);
        updateIsReport(false);
        updateIsComparison(false);

        dispatch(setNavigationLoading(false));
      })();
    } else if ((projectID !== "" || caseId) && hasAffiliations && projectAndAffiliations?.find((x: any) => x.projectID === (caseId ? caseId : projectID))?.liftType === 2) {
      const jetliftNotLoadedForCurrent =
        lastLoadedJetliftRef.current?.projectID !== projectID ||
        lastLoadedJetliftRef.current?.caseId !== caseId;
      if (projectOrCaseChanged || jetliftNotLoadedForCurrent) {
        loadJetliftProjectDetails();
        lastLoadedJetliftRef.current = { projectID: projectID ?? "", caseId: caseId ?? "" };
      }
    }
    if (projectOrCaseChanged) {
      triggerGetSharedCases(projectID);
    }
    if (hasAffiliations) {
      prevProjectIdRef.current = projectID;
      prevCaseIdRef.current = caseId;
    }
  }, [projectID, caseId, projectAndAffiliations]);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      await loadTemplateCalculations();
    };
    if (templateId && templateId?.startsWith("1bb")) {
      fetchData();
    } else if (templateId && templateId?.startsWith("330")) {
      loadJetlifttemplateCalculations();
    }
  }, [templateId]);

  useEffect(() => {
    setProjectStates(
      projectAndAffiliations?.map((x: any) => x.status) as number[]
    );
    const selectProject = projectAndAffiliations?.length > 0 && projectAndAffiliations?.find((x: any) => x.projectID === (caseId ? caseId : projectID));
    projectAndAffiliations?.length > 0 && updateLiftOption({ designType: designType?.[selectProject?.liftType as keyof typeof designType] ?? "", id: selectProject?.liftType });
  }, [projectAndAffiliations, projectDetails]);

  const handleCalculate = () => {
    console.log("handleCalculate");
  };
  const handleSaveClick = () => {
    if (liftOption?.designType === "Jet lift") {
      SaveJetliftProject();
    } else {
      SaveProject();
    }
  };

  const handleCloseDrawer = () => {
    const snapshot = drawerOpenFormSnapshotRef.current;
    if (snapshot) {
      updateProjectName(snapshot.projectName ?? "");
      updateCaseName(snapshot.caseName ?? "");
      updateCustomer(snapshot.customer ?? "");
      updateContact(snapshot.contact ?? "");
      updateWell(snapshot.well ?? "");
      updateWellApiNo(snapshot.wellApiNo ?? "");
      updateFormation(snapshot.formation ?? "");
      updateAccountManager(snapshot.accountManager ?? "");
      updateCountry(snapshot.country ?? "");
      updateState(snapshot.state ?? "");
      updateCounty(snapshot.county ?? "");
      updateOtherCounty(snapshot.countyOther ?? "");
      UpdateCaseDescription(snapshot.caseDescription ?? "");
      if (projectID || caseId) {
        updateStateList(Array.isArray(snapshot.stateList) ? snapshot.stateList : (tab4Input?.stateList ?? []));
        updateCountyList(Array.isArray(snapshot.countyList) ? snapshot.countyList : (tab4Input?.countyList ?? []));
      }
    }
    drawerOpenFormSnapshotRef.current = null;
    setIsDrawerOpen(false);
  };

  const handleOpenDrawer = () => {
    drawerOpenFormSnapshotRef.current = {
      projectName: String(projectName ?? ""),
      caseName: String(caseName ?? ""),
      customer: String(customer ?? ""),
      contact: String(contact ?? ""),
      well: String(well ?? ""),
      wellApiNo: String(wellApiNo ?? ""),
      formation: String(formation ?? ""),
      accountManager: String(accountManager ?? ""),
      country: String(country ?? ""),
      state: String(state ?? ""),
      county: String(county ?? ""),
      countyOther: String(countyOther ?? ""),
      caseDescription: String(caseDescription ?? ""),
      stateList: Array.isArray(stateList) ? [...stateList] : [],
      countyList: Array.isArray(countyList) ? [...countyList] : [],
    };
    setIsDrawerOpen(true);
  };

  const onConfirm = async () => {
    const details = {
      ...tab4Input,
      projectName,
      companyName: customer,
      wellName: well,
      customerContact: contact,
      dalRepr: accountManager,
      caseName,
      formation,
    };
    const updatedAffiliations = projectAndAffiliations?.length > 0 ? (projectAndAffiliations || [])?.map((affiliation: any) => {
      const isTarget = (caseId && affiliation?.projectID === caseId) || (!caseId && affiliation?.projectID === projectID);
      if (isTarget) {
        return {
          ...affiliation,
          caseName,
          caseDescription,
          dalRep: accountManager,
        };
      }
      return affiliation;
    }) : [];
    updatedAffiliations && updateProjectAffiliations(updatedAffiliations);
    updatProjectTabDetails(details);
    setIsDrawerOpen(false);
  };

  const markProjectStatus = async (status: number) => {
    setProjectActionsLoading(true);
    const response = await triggerUpdateProjectStatus({
      id: caseId || projectID,
      status,
      updateTree: true,
    });
    setProjectActionsLoading(false);
    if (response.payload === "Success") {
      showToast(
        status === ProjectStatus.customerReady
          ? "The project is now customer-ready"
          : "The project status is updated to request revisions"
      );
      setTimeout(
        () =>
          updateProjectStatus(
            status === ProjectStatus.customerReady
              ? ProjectStatus.customerReady
              : ProjectStatus.inProgress
          ),
        2000
      );
      await getProjectAndAffiliationsDetails(projectID ?? "");
      projectID && triggerGetSharedCases(projectID);
    } else {
      showToast(
        `Error encountered while transitioning the project to ${status === ProjectStatus.customerReady
          ? "customer-ready"
          : "request revisions"
        } status.`,
        "error"
      );
    }
  };
  const projectSettingBtnOptions = [
    {
      id: 1,
      icon: "",
      label: "Project settings",
      type: "secondary",
      className: "px-[18px] py-3 font-bold text-base",
    },
  ];
  const saveProjectBtnOptions = [
    {
      id: 1,
      icon: "",
      label: "Save project",
      type: "primary",
      className: "px-[18px] py-3 font-bold text-base",
    },
  ];
  const showShareOption =
    user?.userRole?.includes(RoleConstants.admin) ||
    user?.userRole?.includes(RoleConstants.accountManager);

  const projectActionOptions = (() => {
    const options = [] as any;
    if (
      projectStates?.every((status) => status === ProjectStatus.inProgress) &&
      !customerEnabled
    ) {
      options.push({ id: "customerReady", name: "Mark as Customer Ready" });
    }
    if (
      showShareOption &&
      !projectStates?.some((status) =>
        [ProjectStatus.acknowldged, ProjectStatus.inProgress, ProjectStatus.reviewInProgress].includes(status)
      ) &&
      (!customerEnabled && !projectReadOnly)
    ) {
      options.push({ id: "share", name: "Share with customers" });
    }
    if (
      projectStates?.some((status) =>
        [
          ProjectStatus.acknowldged,
          ProjectStatus.customerReady,
          ProjectStatus.needReview,
          ProjectStatus.reviewInProgress,
        ].includes(status)
      ) &&
      !customerEnabled
    ) {
      options.push({ id: "requestRevisions", name: "Request revisions" });
    }
    if (
      projectAndAffiliations?.every((x: any) => [ProjectStatus.reviewInProgress, ProjectStatus.needReview]?.includes(x.status))
    ) {
      if (
        (!customerEnabled || !projectReadOnly) &&
        (user?.userRole?.includes(RoleConstants?.admin) ||
          user?.userRole?.includes(RoleConstants?.accountManager))
      ) {
        options.push({ id: "acknowledge", name: "Acknowledge cases" });
      }
    }

    return options;
  })();

  const onProjectActions = (option: any) => {
    if (option.id === "customerReady") {
      markProjectStatus(ProjectStatus.customerReady);
    } else if (option.id === "share") {
      setShowShareDialog((prev) => !prev);
    } else if (option.id === "requestRevisions") {
      markProjectStatus(ProjectStatus.inProgress);
    } else if (option.id === "acknowledge") {
      setDropdownActive(true);
    }
  };

  return (
    <>
      <ToastContainer />
      <Loader isLoading={loading || projectActionsLoading || jetLiftLoading || projectAffiliationLoading} />
      <Header
        showBreadCrumb={true}
        headerActionTemplate={
          <div className="flex gap-4">
            <ButtonGroup
              buttonOptions={projectSettingBtnOptions}
              handleClick={handleOpenDrawer}
            />
            {((customerEnabled && customerCreated && projectAndAffiliations?.every((item: any) => item?.status !== ProjectStatus?.acknowldged)) || (!customerEnabled && !projectReadOnly)) && (
              <>
                <ButtonGroup
                  buttonOptions={saveProjectBtnOptions}
                  handleClick={handleSaveClick}
                />
              </>
            )}
            {projectActionOptions?.length > 0 && projectID && (
              <Dropdown2
                placeholder="Project actions"
                options={projectActionOptions}
                onSelect={(option: any) => onProjectActions(option)}
              />
            )}
            {showShareOption && (
              <>
                <ShareWithCustomer
                  show={showShareDialog}
                  close={() => setShowShareDialog((prev) => !prev)}
                />
              </>
            )}
            {(dropdownActive || (sharedCases.length > 0 && ((user?.email || "").trim().toLowerCase() === (sharedCases[0]?.email || "").trim().toLowerCase()))) && (
              <>
                <AcknowledgeDropdown
                  dropdownActive={dropdownActive}
                  setDropdownActive={setDropdownActive}
                />
              </>
            )}
          </div>
        }
      />
      {liftOption?.designType === "ESP"
        ? <div className="px-[32px] py-[16px]">
          <ProjectHeader onClickCalculate={handleCalculate} />
          {!isComparison && !isReports && (
            <>
              <ProjectSummary />
              <Splitter
                style={{ minHeight: "400px" }}
                panes={horizontalPanes}
                onChange={onHorizontalChange}
              >
                <InputSection />
                <CalculationSection />
              </Splitter>
            </>
          )}
          {isComparison && !isReports && (
            <>
              <div className="flex flex-col py-[20px]">
                <Comparison />
              </div>
            </>
          )}

          {isReports && (
            <>
              <div className="flex flex-col py-[20px]">
                <Reports />
              </div>
            </>
          )}
        </div>
        : <div className="px-[32px] py-[16px]"><Jetlift /></div>}
      <Drawer
        isOpen={isDrawerOpen}
        onClose={handleCloseDrawer}
        width="w-[1174px]"
        title={"Project settings"}
        onConfirm={onConfirm}
        disabled={projectName == "" || caseName == ""}
      >
        <CreateProject syncFormToProjectTab={!isDrawerOpen} />
      </Drawer>
      <Notification
        isOpen={notification?.show}
        type={notification?.type}
        message={notification?.message}
        onClose={() => setNotification((prev) => ({ ...prev, show: false }))}
      />
    </>
  );
};

export default ProjectDetails;
